import styled from 'styled-components';

const Wrapper = styled.div`
    position: relative;

    .geofence-draw-controls {
      position: absolute;
      top: 10px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      display: flex;
      gap: 0;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
      border-radius: 3px;
      overflow: hidden;
    }

    .geofence-draw-button {
      width: 40px;
      height: 40px;
      border: none;
      background-color: ${(props) => props.theme.colors.white};
      cursor: pointer;
      position: relative;

      &:disabled {
        cursor: default;
        opacity: 0.6;
      }

      &.active {
        background-color: ${(props) => props.theme.colors.main_cta};
      }

      &.geofence-draw-circle::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 18px;
        height: 18px;
        transform: translate(-50%, -50%);
        border: 2px solid #666;
        border-radius: 50%;
      }

      &.geofence-draw-circle.active::before {
        border-color: ${(props) => props.theme.colors.black};
      }

      &.geofence-draw-polygon::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 18px;
        height: 16px;
        transform: translate(-50%, -50%);
        border: 2px solid #666;
        clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
        background: transparent;
      }

      &.geofence-draw-polygon.active::before {
        border-color: ${(props) => props.theme.colors.black};
      }
    }
`;

export default { Wrapper };
